import React from 'react'
import { Route, Link } from 'react-router-dom'
import styled from 'styled-components'

const NavLink = styled.div`
  a {
    transition: color 0.2s, border-bottom-color 0.2s;
    /* color: ${props => props.active ? '#0000ff' : '#666'}; */
    text-decoration: none;
    /* border-bottom: 2px solid;
    border-bottom-color: ${props => props.active ? 'rgba(0, 0, 255, 0.1)' : 'transparent'}; */
    &:hover, &:active, &:focus {
      color: ${props => props.active ? '#0000ff' : '#222'};
    }
  }
`
function handleLinkClick(mobile) {
  window.scrollTo(0, 0);

  if(!mobile) {
    return;
  }
  
  let mobileNav = document.querySelector('.nav-list')
  if(mobileNav.classList.contains('show')) {
      let toggle = document.querySelector('.nav-toggle');
      let header = document.querySelector('header');
      let nav = document.querySelector('.nav-list');
      
      setTimeout(() => {
          mobileNav.classList.remove('show');
          header.classList.remove('show');
          nav.classList.remove('show');
          toggle.classList.remove('active');
      }, 50);
  }
}

export default ({path, exact, ...props, mobile}) => {

  return (
    <Route path={path} exact={exact} children={({match}) => (
      <NavLink active={match} onClick={() => handleLinkClick(mobile)}>
        <Link to={path}>{props.title}</Link>
      </NavLink>
    )} />
  )
}


// WEBPACK FOOTER //
// ./src/components/NavLink.js